import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "notice"]
  static values = {
    endpointKey: String,
    filtered: Boolean,
    empty: Boolean
  }

  connect() {
    if (!this.hasEndpointKeyValue) return

    const protocol = window.location.protocol === "https:" ? "wss" : "ws"
    this.socket = new WebSocket(`${protocol}://${window.location.host}/cable`)

    this.socket.addEventListener("open", () => {
      this.socket.send(JSON.stringify({
        command: "subscribe",
        identifier: this.identifierPayload()
      }))
    })

    this.socket.addEventListener("message", (event) => this.receive(event))
  }

  disconnect() {
    if (!this.socket) return

    if (this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify({
        command: "unsubscribe",
        identifier: this.identifierPayload()
      }))
    }
    this.socket.close()
  }

  receive(event) {
    const packet = JSON.parse(event.data)
    if (!packet.message || packet.type === "ping") return
    if (packet.message.type !== "submission_created") return

    if (this.emptyValue) {
      window.location.reload()
      return
    }

    if (this.filteredValue || !this.hasListTarget) {
      this.showNotice()
      return
    }

    if (this.listTarget.querySelector(`#inbox_row_submission_${packet.message.submission_id}`)) return

    this.listTarget.insertAdjacentHTML("afterbegin", packet.message.html)
    this.showNotice("New submission received")
  }

  showNotice(message = "New submission received. Refresh to apply current filters.") {
    if (!this.hasNoticeTarget) return

    this.noticeTarget.textContent = message
    this.noticeTarget.classList.remove("hidden")
  }

  identifierPayload() {
    return JSON.stringify({
      channel: "EndpointSubmissionsChannel",
      endpoint_key: this.endpointKeyValue
    })
  }
}
